import { FunctionComponent } from "react";
import QPSLogo from "assets/images/qps-logo.png";

const Header: FunctionComponent = () => {
  return (
    <div className="bg-qpblue-500">
      <div className="container mx-auto p-4 flex justify-between relative">
        <a href="https://qpsoftware.cn/">
          <img
            src={QPSLogo}
            className="w-1/2 cursor-pointer"
            alt="QPSoftware Logo"
          />
        </a>
        <a href="https://qpsoftware.net/quote">
          <div className="text-white font-extrabold pt-1">EN</div>
        </a>
      </div>
    </div>
  );
};

export default Header;
